import { IUpSellGenerateViewModel, IUpSellRenderModel } from '../../config/upsell-response';
import { View } from '../view';

export class UpSellProductView extends View {

    container = this.getDFContainer();

    render(model: IUpSellRenderModel) {
        const fields = document.createElement('div');
        fields.classList.add('single-prod-container', 'hs-form', 'df-f', 'hs-form-checkbox', 'df-addon-item');
        model.products.forEach(prod => {
            fields.appendChild(this.generateProductTemplate({ product: prod, currency: model.currency, callback: model.callback, isOneProduct: model.isOneProduct }));
        });
        this.container.appendChild(fields);
    }

    generateProductTemplate(viewModel: IUpSellGenerateViewModel): HTMLElement {
        const elem = document.createElement('div');
        elem.classList.add('upsell-field', 'hs-form-field', 'df-field');

        if (!viewModel.isOneProduct) {
            const selectInput = document.createElement('input') as HTMLInputElement;

            selectInput.type = 'checkbox';
            selectInput.classList.add('df-upsell-product-checkbox', 'hs-input', 'df-product-checkbox', 'df-checkbox');
            selectInput.setAttribute('name', viewModel.product.name);
            selectInput.setAttribute('value', viewModel.product.amount.toString());
            selectInput.setAttribute('payment-type', viewModel.product.type);
            selectInput.setAttribute('id', viewModel.product.id || 'NoIdProvided');

            selectInput.onchange = (ev) => {
                viewModel.callback(viewModel.product, selectInput.checked);
            };

            elem.appendChild(selectInput);
        } else {
            viewModel.callback(viewModel.product, true);
        }

        const prodName = document.createElement('span');
        prodName.classList.add('df-f-label', 'df-f-label-upsell', 'df-f-product-addon-label');
        prodName.innerHTML = `${viewModel.product.name} - ${this.formatMoney(`${viewModel.product.amount}`, viewModel.currency)}`;
        elem.append(prodName);

        if (viewModel.product.showQuantity) {
            const qContainer = document.createElement('span');
            qContainer.setAttribute('q-c-for', this.formProductName(viewModel.product.name));
            qContainer.innerHTML = ` x `;
            elem.append(qContainer);
        }

        return elem;
    }

    formProductName(prodName: string) {
        return prodName.split(' ').join('');
    }

}
